module.exports = __webpack_public_path__ + "img/pause-recording.7496cd86.svg";